import { ReferralStatus } from "@/lib/schema";
import { ReferralStatusBadge } from "./ReferralStatusBadge";

interface ReferralListItemProps {
  referral: {
    id: string;
    candidateName: string;
    jobTitle: string;
    status: ReferralStatus;
  };
  index: number;
}


export function ReferralListItem({ referral, index }: ReferralListItemProps) {
  return (
    <div 
      key={referral.id || index} 
      className="w-full bg-white p-4 hover:bg-gray-50 transition-colors" 
      style={{
        borderWidth: '0px 0px 0.5px 0px',
        borderStyle: 'solid',
        borderColor: '#EAEAEA'
      }}
      data-testid={`referral-item-${index}`}
    >
      <div className="flex justify-between items-center">
        <div className="flex-1 min-w-0">
          <h4 className="font-semibold text-gray-900 truncate">
            {referral.candidateName}
          </h4>
          <p className="text-sm text-gray-500 truncate">
            {referral.jobTitle}
          </p>
        </div>
        <div className="flex items-center gap-4 flex-shrink-0">
          <ReferralStatusBadge 
            status={referral.status}
            index={index}
          />
        </div>
      </div>
    </div>
  );
}
